import React from 'react';
import TransactionsCorporateManagement from "../corporate/TransactionsCorporateManagement";

const TransactionCorporateTab = () => {
    return (
        <>
            <TransactionsCorporateManagement />
        </>
    );
};

export default TransactionCorporateTab;
